/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BundleInterface, UnlockedContentInterface } from '../../+models';
import { SetAssigneeDataInterface, SetAssigneeResponseInterface, UpdateBundleResultInterface } from '../../bundle';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class BundleApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Bundles');
  }

  linkEduContent(bundleId: number, eduContentIds: number[]): Observable<UnlockedContentInterface[]> {
    const path = `${bundleId}/link-edu-content`;
    return this.put(path, undefined, { eduContentIds });
  }

  linkUserContent(bundleId: number, userContentIds: number[]): Observable<UnlockedContentInterface[]> {
    const path = `${bundleId}/link-user-content`;
    return this.put(path, undefined, { userContentIds });
  }

  patchAttributes(id: number, updates: Partial<BundleInterface>): Observable<BundleInterface> {
    const path = `${id}`;
    return this.patch(path, undefined, updates);
  }

  setAssignees(bundleId: number, assigneeData: SetAssigneeDataInterface): Observable<SetAssigneeResponseInterface> {
    const path = `${bundleId}/set-assignees`;
    return this.post<SetAssigneeResponseInterface>(path, undefined, assigneeData);
  }

  destroyBundles(ids: number[]): Observable<UpdateBundleResultInterface> {
    const path = 'destroy-bundles';
    return this.post<UpdateBundleResultInterface>(path, undefined, ids);
  }
}
